import React from 'react';

import { Svg, Path } from 'react-native-svg';

const Pencil = ({ size = '20' }) => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22 22">
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0412 3.06235C16.8222 2.2813 18.0886 2.2813 18.8696 3.06235C19.6507 3.8434 19.6507 5.10973 18.8696 5.89078L20.2838 7.30499C21.8459 5.74289 21.8459 3.21023 20.2838 1.64814C18.7217 0.0860382 16.1891 0.0860382 14.627 1.64814L16.0412 3.06235ZM14.6253 4.47641L17.4538 7.30484L8.96863 15.79L6.1402 12.9615L14.6253 4.47641ZM10.3827 17.2043L9.71176 17.8753C9.70043 17.8878 9.68872 17.9001 9.67664 17.9122L8.96953 18.6193C8.85976 18.7291 8.72593 18.8118 8.57865 18.8609L2.21469 20.9822C1.85536 21.102 1.45919 21.0084 1.19136 20.7406C0.923526 20.4728 0.830003 20.0766 0.949781 19.7173L3.0711 13.3533C3.12017 13.2061 3.20282 13.0723 3.31252 12.9626L3.31162 12.9617L4.72583 11.5475L13.2111 3.0622L14.6253 1.64798L16.0395 3.0622L18.868 5.89062L20.2822 7.30484L18.868 8.71905L10.3827 17.2043ZM7.47162 17.1217L4.81028 14.4603L3.74936 17.6431L4.28886 18.1826L7.47162 17.1217Z"
        />
    </Svg>
);

export default Pencil;
